/**
 * Named crop ratios for `useUppy` `dokaOptions` (e.g. avatar square lock).
 * Listing photos use an unlocked crop (`imageCropAspectRatio` omitted).
 * Literal decimals (not `3 / 2`) so `PinturaCropAspectRatio` stays a narrow union.
 */
export const PINTURA_CROP_ASPECT_RATIOS = {
  Landscape: 1.5, // 3:2
  Portrait: 0.6666666666666666, // 2:3
  Square: 1, // 1:1
} as const

export type PinturaCropAspectRatio = (typeof PINTURA_CROP_ASPECT_RATIOS)[keyof typeof PINTURA_CROP_ASPECT_RATIOS]

/**
 * Pintura default SVG templates for crop toolbar icons ({a}–{d} replaced at
 * runtime). Kept in code (not vue-i18n) to avoid Intlify “HTML in message”
 * warnings. These are not user-facing copy but actual icons.
 *
 * @see @pqina/pintura default locale
 */
export const PINTURA_CROP_ICON_CROP_BOUNDARY
  = '<g fill="currentColor"><rect opacity="{a}" x="2" y="3" width="20" height="20" rx="1"/><rect opacity="{b}" x="7" y="8" width="10" height="10" rx="1"/><rect opacity="{c}" x="4" y="8" width="14" height="14" rx="1"/><rect opacity="{d}" x="12" y="4" width="10" height="10" rx="1"/></g>'

export const PINTURA_CROP_ICON_SELECT_PRESET
  = '<g fill="currentColor"><rect opacity="{a}" x="2" y="4" width="10" height="18" rx="1"/><rect opacity="{b}" x="4" y="8" width="14" height="14" rx="1"/><rect opacity="{c}" x="6" y="12" width="17" height="10" rx="1"/></g>'
